The details about a person's tenure within the position.
